export default class SmoothScroller {
	// クラスの静的プロパティでデフォルトオプションとイージング関数を設定
	static defaultOptions = {
		speed: 500, // スクロール速度
		easing: 'easeInOutExpo' // イージング関数
	};

	// クラスの静的プロパティでイージング関数を設定
	static easingFunctions = {
		'easeInExpo': t => t === 0 ? 0 : Math.pow(2, 10 * (t - 1)), // 最初ゆっくりで、終わりに向かって急速に加速
		'easeOutExpo': t => t === 1 ? 1 : 1 - Math.pow(2, -10 * t), // 最初は速く、終わりに向かって速度が減少
		'easeInOutExpo': t => t < 0.5 ? Math.pow(2, 10 * (t * 2 - 1)) / 2 : (2 - Math.pow(2, -10 * (t * 2 - 1))) / 2 // 最初と最後にゆっくり、途中は速く
	};

	constructor(options = {}, target = null) { // オプションとターゲットを引数に取る
		this.options = { ...SmoothScroller.defaultOptions, ...options }; // デフォルトオプションと引数のオプションをマージ
		this.speed = this.options.speed; // スクロール速度をインスタンスプロパティとして保存
		this.easing = this.setEasingFunction(this.options.easing); // イージング関数をインスタンスプロパティとして保存
		this.scroller = document.scrollingElement || document.documentElement; // スクロール要素をインスタンスプロパティとして保存
		this.target = target;  // ターゲットをインスタンスプロパティとして保存
		// ターゲットが存在する場合はスクロール処理を開始
		if (this.target) {
			this.startScroll(); // スクロール処理を開始
		}
	}

	// イージング関数を設定するメソッド
	setEasingFunction(easing) {
		return SmoothScroller.easingFunctions[easing] || SmoothScroller.easingFunctions['easeInOutExpo']; // イージング関数が存在しない場合はデフォルトのイージング関数を返す
	}

	// スクロール処理を開始するメソッド
	startScroll() {
		const href = this.target.getAttribute('href'); // ターゲットのhref属性を取得
		const scrollTarget = document.getElementById(href.substring(1)); // href属性の値からスクロール先の要素を取得
		if (!scrollTarget) {return;}
		const scrollPaddingTop = parseInt(window.getComputedStyle(document.documentElement).getPropertyValue('scroll-padding-top'), 10) || 0; // スクロール先の要素のpadding-topを取得（<html>に対してscroll-padding-topを設定している場合）※scroll-padding-topが未対応の場合は0
		const targetPosition = scrollTarget.getBoundingClientRect().top + window.scrollY - scrollPaddingTop; // スクロール先の要素の位置を取得
		this.smoothScrollTo(targetPosition); // スクロール処理を開始
	}

	// スムーススクロール処理を行うメソッド
	smoothScrollTo(to) {
		const element = this.scroller; // スクロール要素を取得
		const start = element.scrollTop; // 現在のスクロール位置を取得
		const change = to - start; // スクロール先と現在のスクロール位置の差分を取得
		const duration = this.speed; // スクロール速度を取得
		const startTime = performance.now(); // 開始時間を取得

		// requestAnimationFrameを利用してアニメーション処理を行う
		const animateScroll = () => {
			const now = performance.now(); // 現在の時間を取得
			let elapsed = now - startTime; // 経過時間を取得
			let t = elapsed / duration; // 経過時間とスクロール速度から進捗度を計算
			t = t > 1 ? 1 : t; // 進捗度が1を超えないように調整
			const val = start + change * this.easing(t); // スクロール位置を計算
			element.scrollTop = val; // スクロール位置を更新
			if (t < 1) {
				requestAnimationFrame(animateScroll); // 進捗度が1未満の場合は再帰処理
			}
		};

		requestAnimationFrame(animateScroll); // requestAnimationFrameを利用してアニメーション処理を開始
	}
}